import React, { useState } from "react";
import LeftPanelPreview from "./LeftPanelPreview";
import LeftPanelInterview from "./LeftPanelInterview";
import axios from "axios";
import "../../styles/PositionPanel.css";

const PositionPanel = ({
  data,
  onClose,
  postUserOptions,
  categories,
  orgUnits,
  positionTypes,
  onPositionsUpdate,
}) => {
  const [activeTab, setActiveTab] = useState("preview");
  const [positionData, setPositionData] = useState(data);

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const refreshPosition = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/api/interviews/positions/${data.p_id}`
      );
      setPositionData(res.data);

      if (onPositionsUpdate) {
        onPositionsUpdate(); // 🟢 refresh parent list
      }
    } catch (err) {
      console.error("Failed to refresh position", err);
    }
  };

  return (
    <div className="position-panel-container">
      <div className="position-panel-sidebar">
        <div className="sidebar-title">
          {positionData?.p_position_title || "Position"}
        </div>
        <button
          className={`sidebar-tab ${activeTab === "preview" ? "active" : ""}`}
          onClick={() => setActiveTab("preview")}
        >
          Preview
        </button>
        <button
          className={`sidebar-tab ${activeTab === "interview" ? "active" : ""}`}
          onClick={() => setActiveTab("interview")}
        >
          Interview Questions
        </button>
        <button
          className="sidebar-tab"
          onClick={onClose}
          style={{ marginTop: "auto", color: "red" }}
        >
          Close Panel
        </button>
      </div>

      <div className="position-panel-content">
        {activeTab === "preview" ? (
          <LeftPanelPreview
            data={positionData}
            postUserOptions={postUserOptions}
            categories={categories}
            orgUnits={orgUnits}
            positionTypes={positionTypes}
          />
        ) : (
          <LeftPanelInterview data={positionData} onUpdate={refreshPosition} />
        )}
      </div>
    </div>
  );
};

export default PositionPanel;
